/**
 * Client-side international ship-to detection for outbound queue actions.
 * Keep in sync with `isInternationalShipTo` in `src/api/shipping/commercial-invoice.ts`.
 */

const US_COUNTRY_CODES = new Set([
  "US",
  "USA",
  "UNITED STATES",
  "UNITED STATES OF AMERICA",
]);

const EMPTY_COUNTRY_PLACEHOLDERS = new Set(["", "NONE", "N/A", "NA"]);

const CANADIAN_PROVINCE_CODES = new Set([
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT",
]);

function normalizeCountryToken(raw: string | null | undefined): string {
  return String(raw ?? "")
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");
}

function normalizeProvinceToken(raw: string | null | undefined): string {
  return String(raw ?? "")
    .trim()
    .toUpperCase();
}

/** True when ship-to is outside the United States. */
export function isInternationalShipTo(
  country: string | null | undefined,
  state: string | null | undefined,
): boolean {
  const countryToken = normalizeCountryToken(country);
  const provinceToken = normalizeProvinceToken(state);

  if (countryToken === "CA" || countryToken === "CANADA") return true;
  if (CANADIAN_PROVINCE_CODES.has(provinceToken)) {
    if (EMPTY_COUNTRY_PLACEHOLDERS.has(countryToken) || countryToken === "CA" || countryToken === "CANADA") {
      return true;
    }
  }

  if (EMPTY_COUNTRY_PLACEHOLDERS.has(countryToken)) return false;
  if (US_COUNTRY_CODES.has(countryToken)) return false;
  if (countryToken.includes("UNITED STATES")) return false;
  return true;
}
